import { Layout } from "antd";
import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import AssetTypesTable from "@/components/ListTable/AssetTypesTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import AssetTypeAddButton from "@/modules/asset-type/asset-type-add-button";
import { ListProvider } from "@/modules/list";

const { Content } = Layout;

const AssetTypes = () => {
  const { t } = useTranslation();

  return (
    <>
      <BaseHeader
        title={t("global:assetTypePlural")}
        extra={[<AssetTypeAddButton key="asset-type-add-button" />]}
      />
      <Content>
        <ListProvider
          endpoint="assetTypes"
          storageKey={STORAGE_KEYS.ASSET_TYPE_TEMPLATES}
        >
          <AssetTypesTable />
        </ListProvider>
      </Content>
    </>
  );
};

export default AssetTypes;
